import { IAppState } from '../../../app.types';
import { generateResourceSelectors } from '../../generators/resource.selectors';
import { IBoard } from '../board/board.types';
import * as types from './boardList.types';
export const boardListSelectors = {
  ...generateResourceSelectors<types.IBoardList>((state) => state.resource.boardList),
  selectResourcesByBoardId: (state: IAppState, boardId: IBoard['id']): types.IBoardList[] => {
    const objects = Object.values(state.resource.boardList.byId) as types.IBoardList[];
    return objects.filter((boardList: types.IBoardList) => boardList.boardId == boardId);
  },
};
